//only for numbers to display not calculate
export const formatRateNumber = (rateNumber: number): string => {
  const isInteger: boolean = rateNumber % Math.floor(rateNumber) === 0;

  if (isInteger && rateNumber !== 10) return `${rateNumber}.0`;

  return `${rateNumber}`;
};
